export const MODE_TRENDS = 'trends';
export const MODE_ALERT_DIAGNOSTICS = 'alert-diagnostics';
export const MODE_AI_ALERT_DIAGNOSTICS = 'ai-alert-diagnostics';
